"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AscFixedCostTriggerSchema = exports.AscFixedCostTrigger = void 0;
const zod_1 = __importDefault(require("zod"));
/**
 * What caused a Fixed Cost to be applied. Staff-initiated applies are attributable to a user;
 * sync-initiated ones run inside the ticketing flow with no authenticated user, so this is the
 * only reliable way to tell the two apart when reading the run log.
 */
var AscFixedCostTrigger;
(function (AscFixedCostTrigger) {
    AscFixedCostTrigger["MANUAL"] = "MANUAL";
    AscFixedCostTrigger["TICKETING_SYNC"] = "TICKETING_SYNC";
})(AscFixedCostTrigger || (exports.AscFixedCostTrigger = AscFixedCostTrigger = {}));
exports.AscFixedCostTriggerSchema = zod_1.default.enum([AscFixedCostTrigger.MANUAL, AscFixedCostTrigger.TICKETING_SYNC]);
